module.exports = __webpack_public_path__ + "img/ddwu_thumbnail.90bad6b4.jpg";